module.exports = __webpack_public_path__ + "static/media/check_fuel.e4dcda4e.svg";